export default "__VITE_ASSET__B91ZCfWU__"